import { LogLevel } from '@azure/msal-browser';

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true, // Enable cookies for iframe fallback
  },
  system: {
    allowNativeBroker: false, // Disable native broker to avoid issues
    allowRedirectInIframe: true, // Allow redirects in iframe for silent renewal
    tokenRenewalOffsetSeconds: 300, // Refresh token 5 minutes before expiry
    iframeHashTimeout: 15000, // Increase iframe timeout to 15 seconds (default is 6)
    loadFrameTimeout: 15000, // Increase frame load timeout
    windowHashTimeout: 60000, // Window timeout
    popupWindowTimeout: 60000, // Popup timeout
    loggerOptions: {
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Warning : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Only log warnings and errors in development
        if (level <= LogLevel.Warning) {
          console.log(message);
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

// Use basic scopes that work without custom API setup
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const tokenRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Microsoft Graph API scopes for Planner integration
// Requires Azure admin consent in the App Registration
export const graphPlannerScopes = {
  scopes: ['Tasks.ReadWrite', 'Group.Read.All', 'User.Read'],
};